export default {"src":"/_next/static/media/couponper.5d5a9910.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};